import React, { useEffect, useContext } from 'react'

//Hooks
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//Components
import { Breadcrumb } from 'react-bootstrap';
import SignInContext from '../../contexts/SignIn';
import ScreenHeader from '../../components/ScreenHeader/ScreenHeader';
import SignInContextProvider from '../../components/SignInContextProvider/SignInContextProvider';
import { AuthForm } from '../../components/AuthForm';

//Styles
import Styles from './SignInScreen.module.scss'

const SignInScreen = () => {
    const { route } = useParams();
    const isSignedIn = useSelector(state => state.auth.isSignup);
    const history = useHistory();

    useEffect(() => {
        if (!isSignedIn) {
            return;
        }

        history.push(`/${route}`);
    }, [isSignedIn, route, history]);

    return (
        <SignInContextProvider>
            <Header/>

            <div className={Styles.container}>
                <AuthForm />
            </div>
        </SignInContextProvider>
    )
};


export default SignInScreen

const Header = () => {
    const { state } = useContext(SignInContext);
    const { t } = useTranslation('common');

    return (
        <ScreenHeader >
            <Breadcrumb>
                <Breadcrumb.Item 
                active 
                data-testid={`data-test-breadcrumb-${state}`}
                >
                    {
                        t(`signInScreen.${state}`)
                    }
                </Breadcrumb.Item>
            </Breadcrumb>
        </ScreenHeader>
    );
}
